import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function CompanyAdminSurprise({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
      enableBackground="new 0 0 144 143.9955139"
      xmlSpace="preserve"
    >
      <g id="athena">
        <g id="surprise_4_">
          <ellipse
            fill="#A6E3F9"
            cx="72"
            cy="71.9977722"
            rx="72"
            ry="71.9977722"
          />
          <g>
            <g>
              <defs>
                <ellipse id="SVGID_1_" cx="72" cy="72.0022278" rx="72" ry="71.9977722" />
              </defs>
              <clipPath id="SVGID_2_">
                <use
                  xlinkHref="#SVGID_1_"
                  overflow="visible"
                />
              </clipPath>
              <g
                id="profil_5_"
                clipPath="url(#SVGID_2_)"
              >
                <g>
                  <g>
                    <g>
                      <path
                        fill="#E2AE44"
                        d="M105.0084534,50.8364639c-1.6024857-20.761549-19.7235565-36.2855873-40.484993-34.6832199 c-20.761097,1.6024818-36.2855911,19.7233276-34.6832199,40.484993 c1.6024818,20.7611008,19.7238922,36.2855911,40.484993,34.6832199l17.6813812-20.637886 c10.1758728-0.7854538,17.7883148-9.6715775,17.0028534-19.8472176L105.0084534,50.8364639z"
                      />
                      <path
                        fill="#E2AE44"
                        d="M32.3218651,58.5291634l-7.7651882,4.4986725 c-7.5855122,4.3946953-11.9806547,12.7483482-11.3060808,21.4889641l1.535387,19.8920288l0,0 c12.5582647-0.9693222,21.9529762-11.9355087,20.9837685-24.4938889l-1.6613159-21.5235863L32.3218651,58.5291634z"
                      />
                      <path
                        fill="#00AFEC"
                        d="M84.3432388,111.1691666c-6.3853607,4.1944656-8.1615448,12.7711182-3.9672089,19.1569901 c0.3359299,0.5113983,0.709343,0.9819641,1.097847,1.4335022l-0.0113144,0.0083771l36.0920334,42.3852386 l18.0093079-10.2062225l-32.0634308-48.8111649C99.3059998,108.7505188,90.7288361,106.974205,84.3432388,111.1691666z"
                      />
                      <path
                        fill="#00AFEC"
                        d="M84.3432388,111.1691666c-6.3853607,4.1944656-8.1615448,12.7711182-3.9672089,19.1569901 c0.3359299,0.5113983,0.709343,0.9819641,1.097847,1.4335022l-0.0113144,0.0083771l25.4502563,29.8879089 l17.3280945-14.946228l-20.7404404-31.5738297C99.3059998,108.7505188,90.7288361,106.974205,84.3432388,111.1691666z"
                      />
                      <circle
                        fill="#00AFEC"
                        cx="91.5514145"
                        cy="122.8875504"
                        r="14.2310104"
                      />
                      <path
                        fill="#00AFEC"
                        d="M105.705101,123.545517l-3.6839752,79.6075287H51.115696l-21.0365047-83.6018448 c-1.3915749-5.5305023,2.7898235-10.8946075,8.4928493-10.8946075h52.917263 C99.6071091,108.6565933,106.0803604,115.4363556,105.705101,123.545517z"
                      />
                      <path
                        fill="#FDC9A3"
                        d="M48.6074677,112.3241959c-5.8337288-5.266571-14.8323288-4.8069077-20.0994473,1.026825 c-0.4217854,0.4672165-0.7932148,0.9611359-1.1417656,1.4651337l-0.0112743-0.0090866l-34.1684494,49.4098663 l16.1894207,12.8011322l40.2588806-44.5943146C54.9014091,126.5900192,54.4417458,117.5908737,48.6074677,112.3241959z"
                      />
                      <path
                        fill="#00AFEC"
                        d="M48.6074677,112.3241959c-5.8337288-5.266571-14.8323288-4.8069077-20.0994473,1.026825 c-0.4217854,0.4672165-0.7932148,0.9611359-1.1417656,1.4651337l-0.0112743-0.0090866L5.293314,146.7097168 l17.9512691,14.946228l26.390255-29.232193C54.9014091,126.5900192,54.4417458,117.5908737,48.6074677,112.3241959z"
                      />
                      <path
                        fill="#283042"
                        d="M108.038208,58.5831909c-0.0118256,0.0094757-0.0118256,0.0094757-0.0118256,0.0094757"
                      />
                      <path
                        fill="#FDC9A3"
                        d="M60.3528709,110.5709381c1.0720329,6.5634537,7.2617607,11.0150223,13.8252144,9.9429855 c6.5634537-1.0720291,11.0150223-7.2618637,9.9429855-13.8253174 c-1.0720291-6.5634537-7.2618637-11.0150223-13.8252106-9.9429932 C63.7324104,97.8176498,59.2807274,104.0074844,60.3528709,110.5709381z"
                      />
                      <polygon
                        fill="#FDC9A3"
                        points="84.1210709,106.6886063 60.3528709,110.5709381 55.5723457,81.3036499 56.2696609,81.1897507 79.3406601,77.4214325"
                      />
                      <path
                        fill="#FDC9A3"
                        d="M70.6965103,28.1777382l-1.8487167,0.3020267 c-11.7986069,1.9270992-19.8009262,13.0539989-17.8737183,24.8524952l6.5731964,40.2429047l22.3778305-3.6551819 c11.2382355-1.8356934,18.8604736-12.4340744,17.0247879-23.6722031l-3.5514069-21.7430153 C91.6381073,33.7271767,81.4739838,26.4173622,70.6965103,28.1777382z"
                      />
                      <line
                        fill="none"
                        stroke="#0E0E11"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        x1="84.170929"
                        y1="54.7537537"
                        x2="89.9461517"
                        y2="54.3149414"
                      />
                      <line
                        fill="none"
                        stroke="#0E0E11"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        x1="69.2432938"
                        y1="55.3939896"
                        x2="75.5121841"
                        y2="55.0136719"
                      />
                      <path
                        fill="#FDC9A3"
                        d="M51.6519966,69.5194321l4.9126091-0.7988129L55.7685471,63.8181 c-0.4396324-2.7075272-2.9955521-4.5447655-5.7086525-4.103611l0,0 c-2.713192,0.4411736-4.5561829,2.9938049-4.1164627,5.701313l0,0 C46.3830833,68.1234207,48.9389114,69.9606781,51.6519966,69.5194321z"
                      />

                      <ellipse
                        transform="matrix(0.9984514 -0.0556306 0.0556306 0.9984514 -3.2927907 4.1342959)"
                        fill="#0E0E11"
                        cx="72.612999"
                        cy="61.2115974"
                        rx="1.6323242"
                        ry="2.106411"
                      />

                      <ellipse
                        transform="matrix(0.9984514 -0.0556306 0.0556306 0.9984514 -3.2274106 4.9155741)"
                        fill="#0E0E11"
                        cx="86.6788559"
                        cy="60.4278908"
                        rx="1.6323242"
                        ry="2.106411"
                      />
                      <path
                        fill="#E2AE44"
                        d="M49.3236198,60.3561172l-2.6704369,0.272583l-1.4715576-30.5739059l45.5499954-4.6537323 l2.7279282,15.4226837l-2.1721497,0.2626114c-8.8146896,0.9005394-17.0901566,4.700573-23.5703506,10.8235092 l-0.0001144,0.0000038C62.66008,56.6878281,56.202282,59.6533089,49.3236198,60.3561172L49.3236198,60.3561172z"
                      />
                    </g>
                  </g>
                </g>
                <path
                  fill="#00AFEC"
                  d="M68.6254883,143.8550873l21.0233765-15.9402695l16.8584671,22.2262344l-0.0120697,0.0089264 c0.9376755,1.2358246,1.6827011,2.6490936,2.1483459,4.2252655c2.0631256,6.9854431-1.9269867,14.3204803-8.9123306,16.383606 c-5.4091568,1.5979919-11.0171432-0.4447479-14.2353516-4.6869507l-0.0120697,0.0094299L68.6254883,143.8550873z"
                />
                <g>
                  <polygon
                    fill="#FDC9A3"
                    points="133.4762115,173.5890198 164.1596527,127.7633133 153.4921875,119.8304214 116.8368759,160.8465271"
                  />
                </g>
              </g>
            </g>
          </g>
          <ellipse
            fill="#FFFFFF"
            cx="82.6591187"
            cy="76.8569107"
            rx="1.8414383"
            ry="2.4704971"
          />
        </g>
      </g>
    </svg>
  );
}

export default CompanyAdminSurprise;
